import React from 'react';
import Header from 'components/header/Header';
import SystemUpdates from './components/SystemUpdates';
import NotificationsList from './components/NotificationsList';

const NotificationsView = () => {
    return (
        <div>
            <Header title="Notifications" />
            <div className="mt-8 block lg:grid lg:grid-cols-3 gap-24">
                <NotificationsList />
                <SystemUpdates />
            </div>
        </div>
    );
};

export default NotificationsView;
